import React, { useMemo } from 'react';
import Img from './Img';
import useElementSize from '../hooks/useElementSize';
import { gridMetrics, justifyRows } from '../utils/layout';

/** Uncropped photos in justified rows; tapping one calls onOpen(index). */
const JustifiedGrid = ({ images, onOpen, altFor }) => {
  const [ref, { width }] = useElementSize();

  const { rows, gap } = useMemo(() => {
    const metrics = gridMetrics(width);
    const indexed = images.map((image, index) => ({ image, index, aspect: image.aspect }));
    return { rows: justifyRows(indexed, width, metrics), gap: metrics.gap };
  }, [images, width]);

  return (
    <div ref={ref} className="jgrid" style={{ '--gap': `${gap}px` }}>
      {rows.map((row) => (
        <div key={row.items[0].index} className="jgrid__row" style={{ height: row.height }}>
          {row.items.map(({ image, index }, j) => {
            const alt = altFor(image, index);
            return (
              <figure
                key={image.src}
                className="jgrid__item"
                style={row.last ? { width: row.widths[j] } : { flexGrow: row.shares[j], flexBasis: 0 }}
              >
                <button type="button" className="jgrid__open" onClick={() => onOpen(index)} aria-label={`Open photo ${index + 1}`}>
                  <Img image={image} alt={alt} sizes={`${Math.ceil(row.widths[j] / 50) * 50}px`} />
                </button>
                {image.caption && <figcaption className="sr-only">{image.caption}</figcaption>}
              </figure>
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default JustifiedGrid;
